import React, { forwardRef } from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';
var styles = xcss({
  /* Reset inherited styles from toolbar */
  whiteSpace: 'initial',
  textAlign: 'initial',
  boxShadow: 'elevation.shadow.overflow',
  width: '340px',
  padding: 'space.200',
  borderRadius: 'radius.small',
  backgroundColor: 'elevation.surface.overlay'
});
export var MediaInsertWrapper = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(Box, {
    ref: ref,
    xcss: styles
  }, children);
});